import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/custom.scss';
import './index.css';
import 'bootstrap/dist/js/bootstrap.esm.min';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);